const others = {
    terms_of_use: {
        title: 'TERMOS DE USO',
        terms_of_use: 'URL dos termos de uso',
        terms_of_use_placeholder: 'https://your.terms.of.use/',
        privacy_policy: 'URL da política de privacidade',
        privacy_policy_placeholder: 'https://your.privacy.policy/',
    },
    languages: {
        title: 'IDIOMAS',
        enable_auto_detect: 'Ativar detecção automática',
        description: 'Seu software detecta a configuração de localidade do usuário e muda para o idioma local. Você pode adicionar novos idiomas traduzindo a interface do usuário do inglês para outro idioma.',
        manage_language: 'Gerenciar idioma',
        default_language: 'Idioma padrão',
        default_language_description_auto: 'O idioma padrão será usado quando o idioma do usuário detectado não estiver coberto na biblioteca de idiomas atual.',
        default_language_description_fixed: 'Quando a detecção automática está desativada, o idioma padrão é o único idioma que seu software mostrará. Ative a detecção automática de extensão de idioma.',
    },
    manage_language: {
        title: 'Gerenciar idioma',
        subtitle: 'Localize a experiência do produto adicionando idiomas e traduções. Sua contribuição pode ser definida como o idioma padrão.',
        add_language: 'Adicionar idioma',
        logto_provided: 'Fornecido por Logto',
        key: 'Chave',
        logto_source_values: 'Valores Logto',
        custom_values: 'Valores personalizados',
        clear_all_tip: 'Limpar todos os valores',
        unsaved_description: 'As alterações não serão salvas se você sair desta página sem salvar.',
        deletion_tip: 'Excluir o idioma',
        deletion_title: 'Deseja excluir o idioma adicionado?',
        deletion_description: 'Após a exclusão, seus usuários não poderão navegar naquele idioma novamente.',
        default_language_deletion_title: 'O idioma padrão não pode ser excluído.',
        default_language_deletion_description: '{{language}} está definido como seu idioma padrão e não pode ser excluído. ',
    },
    advanced_options: {
        title: 'OPÇÕES AVANÇADAS',
        enable_user_registration: 'Ativar registro de usuário',
        enable_user_registration_description: 'Habilitar ou desabilitar o registro do usuário. Depois de desativados, os usuários ainda podem ser adicionados no Admin Console, mas os usuários não podem mais estabelecer contas por meio da interface do usuário de login.',
    },
};
export default others;
